export const BAZISNET = 1;
export const UFS = 10;
export const OVB = 462;
export const MENTOR = 16;
// Remove this gate when the mentor dealer flow goes live.
export const MENTOR_DEALER_FLOW_ENABLED = false;
export const mentorDealerFlowEnabled = (companyId) => MENTOR_DEALER_FLOW_ENABLED && +companyId === MENTOR;
export const HUNPARTNER = 493;
export const HUNGARIKUM = 524;
export const HUNDEALER = 564;
export const MONEY_MORE = 555;
export const KOROSBLANK = 307;
export const HUNBENEFIT = 575;
